import {
  StyledProps,
  React,
  withStyles,
  observable,
  CentricTheme,
  classNames
} from '@api'
import {Button} from '@material-ui/core'
import {InsertPhoto} from '@material-ui/icons'
import {DragDropEventHandlers, DropTargetType, globalStores, Stores} from '@stores'
import {autorun, computed} from 'mobx'
import {disposeOnUnmount} from 'mobx-react'
import * as css from './DropTarget.css'
import {DragEventPlaceholders} from 'centric-ui-components'
import {observer} from 'mobx-react'

interface MyProps extends StyledProps {
  className?: any;
  id?: string /* Unique name for this drop placeholder - will use targetType if not specified */
  /**
   * The type to set for the drop descriptor
   */
  targetType: DropTargetType
  showDropBackground?: boolean;
  isOver?: boolean;
  isOverCurrent?: boolean;
  canDrop?: boolean;
  zoneInfo?: any;
  libraryItem?: any;
  allowedDropEffect?: string;
  accepts?: string[];
  children?: any;
  showTitle?: boolean;
  title?: string;
  type?: string
  viewBy?: string
  visible: boolean
  disabled: boolean
  title1?: string
  subtitle?: string
  isImage?: boolean
  stores: Partial<Stores>
}

const styles = (theme: CentricTheme) => ({
  dragWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    marginLeft: theme.spacing(),
    width: 'calc(100% - 48px)'
  },
  icon: {
    width: `${theme.spacing() * 5 - 4} !important`,
    height: `${theme.spacing() * 5 - 4} !important`
  },
  subText: {
    color: 'rgba(66, 66, 66, 0.5)'
  }
})

@((withStyles as any)(styles))
@observer
export class DropTarget extends React.Component<MyProps> {
  @observable isDragOver: boolean = false

  componentDidUpdate(prevProps: Readonly<MyProps>, prevState: Readonly<{}>, snapshot?: any) {
    if (!this.props.visible && this.isDragOver) {
      this.isDragOver = false
    }
  }

  static defaultProps = {
    showTitle: true,
    title: 'Products',
    type: 'Items',
    visible: true,
    disabled: false
  }

  get dropTargetId() {
    const {props: {id, targetType}} = this
    return id ?? targetType
  }

  constructor(props) {
    super(props)

    this.dragDropEvents = new DragDropEventHandlers(props.stores.catalog, {id: this.dropTargetId, target: this.props.targetType})
  }

  dragDropEvents : DragDropEventHandlers

  @computed get somethingDragOverMe() {
    return this.props.stores.dragDrop?.dragOverItem?.id === this.dropTargetId
  }

  @computed get somethingDroppedOverMe() {
    return this.dragDropEvents.state === 'loading'
  }

  render() {
    const {
      isDragOver,
      somethingDroppedOverMe, somethingDragOverMe, dropTargetId, dragDropEvents,
      props: {visible, className, children, title, showTitle, classes, type, viewBy, id, targetType, disabled, title1, subtitle, ...props}
    } = this
    let {props: {isImage}} = this
    isImage = isImage || _.toLower(type) === 'images'
    return (
      <div
        className={classNames(className, css.root)}
        {...dragDropEvents.events}
        data-drag-over={somethingDragOverMe}
        data-visible={visible || somethingDroppedOverMe}
      >
        <DragEventPlaceholders id={dropTargetId} dropType={targetType}/>
        <Button
          disableFocusRipple
          disableRipple
          disableTouchRipple
          className={css.button}
          classes={{
            outlinedPrimary: css.outlinedPrimary,
            containedPrimary: css.containedPrimary,
            outlinedSecondary: css.outlinedSecondary,
            containedSecondary: css.containedSecondary
          }}
          variant={'outlined'}
          //color={isDragOver ? "secondary" : "primary"}
        >
          {isImage && <InsertPhoto classes={{root: classes.icon}}/>}
          {showTitle && (
            <div className={classes.dragWrapper}>
              <div className={classNames(css.title, css.ellipsis)}>
                {title1 ? title1 : `Create ${type}`}
              </div>
              <div
                className={classNames(css.subTitle, css.ellipsis, {
                  [classes.subText]: !isDragOver
                })}
              >
                {subtitle ? subtitle : viewBy && !isImage ? `Assign to ${title}` : `Create New ${title}`}
              </div>
            </div>
          )}
        </Button>
        {children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/common/components/DropTarget.tsx